define(
  'app/views/dc_verify_phone_number_view',['app/setup'],
  function (takhfifan) {

    takhfifan.dcVrifyPhoneNumber = Backbone.View.extend({

      events: {
        'click .tkh-gebb': 'submit',
        'submit .tkh-dc-verification-modal__phone': 'submitPhoneNumber',
        'submit .tkh-dc-verification-modal__code': 'submitVerificationCode'
      },

      initialize: function (options) {
        // this.$el = this.$('.tkh-dc-verification-modal');
        this.$verificationPhoneForm = this.$('.tkh-dc-verification-modal__phone');
        this.$verificationCodeForm = this.$('.tkh-dc-verification-modal__code');

        takhfifan.eventHub.on('dc:verifyPhoneNumber', function (options) {
          this.pid = options.pid;
          this.showPopup();
        }, this);

        takhfifan.eventHub.on('modal:disableTriggerElement', function(options) {
          this.$el.hide();
          this.$('.loading-view').removeClass('loading-view');
        }, this);
      },

      showPopup: function () {
        takhfifan.eventHub.trigger('modal:showModalWithContent',
          {
            triggerElement: this.$el,
            fadeTimeIn: 400,
            elementToOperate: this.$el
          });
        this.$el.find('form').hide();
        this.$verificationCodeForm[0].reset();
        this.$verificationPhoneForm.show();
      },

      submitPhoneNumber: function (e) {
        e.preventDefault();
        var _this = this;
        this.$verificationPhoneForm.addClass('loading-view');
        this.customerPhoneNumber = this.$verificationPhoneForm.find('input[name="phone"]').val();

        $.ajax({
          url: this.$verificationPhoneForm.prop('action'),
          type: this.$verificationPhoneForm.prop('method'),
          data: {
            mobile: this.customerPhoneNumber,
            form_key: takhfifan.formKey,
            pid: this.pid
          }
        }).done(function (data) {
          if (data.success) {
            _this.$verificationPhoneForm.hide();
            _this.$verificationCodeForm.show();
            _this.$verificationCodeForm[0].reset();
          } else {
            takhfifan.eventHub.trigger('modal:closeModalWithContent');
            takhfifan.eventHub.trigger('message:show', {
              type: 'error',
              msg: data.message ? data.message : "در برقراری ارتباط خطایی پیش آمد"
            });
          }
        }).fail(function () {
          takhfifan.eventHub.trigger('modal:closeModalWithContent');
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: "در برقراری ارتباط خطایی پیش آمد"
          });
        }).always(function () {
          _this.$verificationPhoneForm.removeClass('loading-view');
        });
      },

      submitVerificationCode: function (e) {
        e.preventDefault();
        var _this = this,
            verificationCode = this.$verificationCodeForm.find('input[name="code"]').val();
        this.$verificationCodeForm.addClass('loading-view');
        $.ajax({
          url: this.$verificationCodeForm.prop('action'),
          type: this.$verificationCodeForm.prop('method'),
          data: {
            mobile: this.customerPhoneNumber,
            code: verificationCode,
            form_key: takhfifan.formKey
          }
        }).done(function (data) {
          if (data.success) {
            takhfifan.eventHub.trigger('dc:checkoutProcess'+ _this.pid, _this.pid);
          } else {
            takhfifan.eventHub.trigger('modal:closeModalWithContent');
            takhfifan.eventHub.trigger('message:show', {
              type: 'error',
              msg: data.message ? data.message : "در برقراری ارتباط خطایی پیش آمد"
            });
          }
        }).fail(function () {
          takhfifan.eventHub.trigger('modal:closeModalWithContent');
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: "در برقراری ارتباط خطایی پیش آمد"
          });
        })
      }
    })
  });
